import React from 'react';
import { Spinner, ISpinnerProps, FlexBox, Typography } from '@agilepoint/wat-react-ux';

type TextAlign = 'top' | 'bottom' | 'left' | 'right';

interface ICenteredSpinnerProps extends ISpinnerProps {
    text?: string;
    textAlign?: TextAlign;
    width?: string;
    height?: string;
}

export const CenteredSpinner = React.memo((props: ICenteredSpinnerProps) => {
    const { text, textAlign = 'bottom', height = '100%', width = '100%', ...spinnerProps } = props;
    const getDirection = React.useMemo(() => {
        switch (textAlign) {
            case 'top':
                return 'column';
            case 'bottom':
                return 'column-reverse';
            case 'left':
                return 'row';
            default: return 'row-reverse';
        }
    }, [textAlign]);

    return (
        <FlexBox height={height} width={width} flexDirection={getDirection} style={{ gap: '8px' }} alignItems="center" justifyContent="center">
            {text ? <Typography.Small>{text}</Typography.Small> : null}
            {React.createElement(Spinner, spinnerProps)}
        </FlexBox>
    );
});
